"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerDialog = DatePickerDialog;
var _dialog = require("@react-aria/dialog");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _popover = require("../../popover/popover.tokens");
var _jsxRuntime = require("react/jsx-runtime");
var StyledDialog = _styledComponents.default.div.withConfig({
  displayName: "DatePickerDialog__StyledDialog",
  componentId: "sc-6cz8v2-0"
})(["display:table-cell;background-color:white;", ";border-radius:", ";border:", ";padding:", ";"], _popover.tokens.shadow, _popover.tokens.border.radius, _popover.tokens.border.default, _popover.tokens.padding.default);
function DatePickerDialog(_ref) {
  var title = _ref.title,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["title", "children"]);
  var ref = _react.default.useRef();
  var _ref2 = (0, _dialog.useDialog)(props, ref),
    dialogProps = _ref2.dialogProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDialog, _objectSpread({}, dialogProps, {
    ref: ref,
    children: children
  }));
}